import { Button, Card, Container, Stack } from '@mui/material';
import DataGridCustom from 'src/components/data-grid-custom';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Iconify from 'src/components/iconify';
import Page from 'src/components/page/page';
import { BenefitsTableToolbar } from 'src/modules/benefits/benefits-list/components/benefits-table-toolbar';
import { paths } from 'src/routes/paths';
import useLPEventsList from './events-lp-list.hook';

export default function LpEventsList() {
  const hook = useLPEventsList();

  return (
    <Page title="Lista de Eventos — Viva Visitante">
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading="Lista de Eventos — Viva Visitante"
          links={[]}
          sx={{ mb: 3 }}
          action={
            <Stack direction="row" spacing={2}>
              {hook.canCopy && hook.selectedEvent && (
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<Iconify icon="lucide:copy" width={16} />}
                  onClick={() => {
                    if (hook.selectedEvent)
                      hook.navigate(paths.dashboard.lpEventClone(hook.selectedEvent._id));
                  }}
                >
                  Copiar Evento
                </Button>
              )}
              <Button
                size="small"
                variant="contained"
                startIcon={<Iconify icon="lucide:plus" width={16} />}
                onClick={() => hook.navigate(paths.dashboard.lpEventCreate)}
                disabled={!hook.permissions?.create}
              >
                Cadastrar Evento do Viva Visitante
              </Button>
            </Stack>
          }
        />
        <Card sx={{ px: 2, pt: 1, pb: 0, boxShadow: 4 }}>
          <DataGridCustom
            animatedEachRow
            excludeExportButton
            columns={hook.columns}
            rows={hook.rows}
            customFilters={
              <BenefitsTableToolbar
                searchText={hook.search}
                searchTooltip="Pesquise pelo nome, detalhe ou responsável pela atualização."
                setSearchText={hook.setSearch}
                selectedFiltersCount={0}
              />
            }
            filteredRowsCount={hook.rows.length}
            totalRowsCount={hook.total}
            initialVisibleColumns={{}}
            onRowClick={({ row }) => hook.navigate(paths.dashboard.lpEventDetails(row.id))}
            sortModel={hook.sortModel}
            setSortModel={hook.setSortModel}
            sortingMode="client"
            paginationModel={hook.paginationModel}
            setPaginationModel={hook.setPaginationModel}
            paginationMode="client"
            pageSizeOptions={[5, 10, 20, 30, 40, 50]}
            checkboxSelection={hook.canCopy}
            singleSelection
            rowSelectionModel={hook.selectedRows}
            onRowSelectionModelChange={hook.setSelectedRows}
            isLoading={hook.isLoading}
            height={550}
          />
        </Card>
      </Container>
    </Page>
  );
}
